import { getHasMoreColours } from "../state/modules/search/product/mapAndInsertProducts/getHasMoreColours";

export const mapAnalyticsProducts = ({ products }) =>
  products.map(
    ({
      id,
      productCode,
      description,
      reducedPrice,
      price,
      brandName,
      colour,
      facetGroupings
    }) => ({
      id,
      productCode,
      description,
      priceLocalCurrency: reducedPrice || price,
      brandName,
      colour,
      hasMoreColours: getHasMoreColours({
        facetGroupings
      })
    })
  );
